import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import * as style from './style.css';
import { PlanNotAvailable } from '../../../FloorPlan/FloorPlan/components/PlanNotAvailable';
import { jsx as _jsx } from "react/jsx-runtime";
export var FlatImage = function FlatImage(_ref) {
  var src = _ref.src;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var onError = React.useCallback(function () {
    return setError(true);
  }, []);
  if (error) {
    return /*#__PURE__*/_jsx(PlanNotAvailable, {
      isFloorPlanNotAvailable: true
    });
  }
  return /*#__PURE__*/_jsx("img", {
    className: style['image'],
    src: src,
    alt: "\u041F\u043B\u0430\u043D \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B",
    onError: onError
  });
};